import React, { useMemo, useState } from 'react';
import { Form, InputNumber, Typography, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { currencyInputProps } from '../../../utils/numberInputMask';
import { simularQuantoGuardar, formatBRL } from '../../../utils/simuladores';
import SimuladorResultado from './SimuladorResultado';

const { Text } = Typography;

function QuantoGuardarForm() {
    const navigate = useNavigate();
    const [values, setValues] = useState({
        valorObjetivo: null,
        prazoMeses: 12,
    });

    const resultado = useMemo(() => simularQuantoGuardar(values), [values]);

    const onChange = (field) => (val) => {
        setValues((prev) => ({ ...prev, [field]: val }));
    };

    const criarObjetivo = () => {
        if (!resultado) return;
        const dataLimite = new Date();
        dataLimite.setMonth(dataLimite.getMonth() + resultado.prazoMeses);
        const yyyy = dataLimite.getFullYear();
        const mm = String(dataLimite.getMonth() + 1).padStart(2, '0');
        const dd = String(dataLimite.getDate()).padStart(2, '0');
        const params = new URLSearchParams({
            aba: 'poupanca',
            valor_alvo: String(resultado.valorObjetivo),
            data_limite: `${yyyy}-${mm}-${dd}`,
            criar: '1',
        });
        navigate(`/metas?${params.toString()}`);
    };

    return (
        <div className="simulador-form">
            <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
                Informe o valor que quer juntar e em quantos meses. A sugestão é sem juros — só divisão do objetivo pelo prazo.
            </Text>
            <Form layout="vertical">
                <Form.Item label="Valor do objetivo">
                    <InputNumber
                        {...currencyInputProps({ min: 0 })}
                        value={values.valorObjetivo}
                        onChange={onChange('valorObjetivo')}
                    />
                </Form.Item>
                <Form.Item label="Prazo (meses)">
                    <InputNumber
                        min={1}
                        max={120}
                        style={{ width: '100%' }}
                        value={values.prazoMeses}
                        onChange={onChange('prazoMeses')}
                        inputMode="numeric"
                    />
                </Form.Item>
            </Form>

            {resultado && (
                <>
                    <SimuladorResultado
                        veredicto={{
                            tipo: 'positivo',
                            titulo: 'Aporte mensal sugerido',
                            detalhe: `Para juntar ${formatBRL(resultado.valorObjetivo)} em ${resultado.prazoMeses} meses, reserve cerca de ${formatBRL(resultado.parcelaMensal)} por mês (sem juros).`,
                        }}
                        stats={[
                            { title: 'Objetivo', value: formatBRL(resultado.valorObjetivo) },
                            { title: 'Prazo', value: `${resultado.prazoMeses} meses` },
                            { title: 'Aporte mensal sugerido', value: formatBRL(resultado.parcelaMensal) },
                        ]}
                    />
                    <Space style={{ marginTop: 16 }}>
                        <Button type="primary" onClick={criarObjetivo}>
                            Criar objetivo com este valor
                        </Button>
                    </Space>
                    <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 13 }}>
                        Abre Metas → Juntar dinheiro. O aporte continua manual — nada é transferido sozinho.
                    </Text>
                </>
            )}
        </div>
    );
}

export default QuantoGuardarForm;
